// Hiring: what its address can open. No React in here.
//
// The dashboard opens on its openings. One list opens by address (?list=<slug>): the
// Notice period tab narrowed to the people serving notice whom no hiring replaces yet
// (nothing raised or linked for them), which is where the home screen's Hiring card in
// "Needs attention" lands, on exactly the rows it counts. HiringDashboardTab reads the
// slug; the server narrows the tab (GET /hiring-links/:projectId/notice?hiring=not_raised).
//
// It is not offered in page search (navigation/searchIndex: Hiring lists none there): the
// tab's own search and status filter stay in the page, and this list is the home card's.

export const HIRING_LIST = { noticeNotRaised: 'notice-not-raised' } as const;
